import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleCollectionFetchPending,
  handleCollectionFetchRejected,
  handleCollectionFetchFulfilled,
} from "redux/helpers/fetching"
import { fetchPlans } from "redux/features/plan/planThunk"

const planAdapter = createEntityAdapter()
export const initialState = planAdapter.getInitialState({
  fetchCollectionStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})
export const planSlice = createSlice({
  name: "plan",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchPlans.pending, (state) =>
        handleCollectionFetchPending(state),
      )
      .addCase(fetchPlans.rejected, (state) =>
        handleCollectionFetchRejected(state),
      )
      .addCase(fetchPlans.fulfilled, (state, { payload }) => {
        planAdapter.setAll(state, payload)
        handleCollectionFetchFulfilled(state)
      })
  },
})

export const { selectById: selectPlanById, selectAll: selectPlans } =
  planAdapter.getSelectors((state: RootState) => state.features.plan)
export const selectFetchCollectionStatus = (state: RootState) =>
  state.features.plan.fetchCollectionStatus

export default planSlice.reducer
